<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">
        Customer Retur
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm"
            >Delete</b-button
          >
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button
            class="btn btn-primary mr-1"
            @click="showFilter = !showFilter"
          >
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend
              ><label style="width: 120px !important"
                >Input Retur Date</label
              ></b-input-group-prepend
            >
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend
              ><span class="input-group-text"
                >until</span
              ></b-input-group-prepend
            >
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend
              ><label style="width: 120px !important"
                >Order Date</label
              ></b-input-group-prepend
            >
            <b-form-input v-model="tblData.tglD1" type="date"></b-form-input>
            <b-input-group-prepend
              ><span class="input-group-text"
                >until</span
              ></b-input-group-prepend
            >
            <b-form-input v-model="tblData.tglD2" type="date"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend
              ><label style="width: 120px !important"
                >Item Category</label
              ></b-input-group-prepend
            >
            <b-form-select
              v-model="tblData.itemcategory"
              :plain="true"
              :options="itemCategories"
            ></b-form-select>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend
              ><label>Customer Group</label></b-input-group-prepend
            >
            <b-form-select
              v-model="tblData.customer_group"
              :plain="true"
              :options="custgroup"
              @change="reloaddata"
            ></b-form-select>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend
              ><label style="width: 130px !important"
                >Customer</label
              ></b-input-group-prepend
            >
            <b-form-input
              v-model="tblData.CustName"
              placeholder="Customer Name"
              @change="customerChange"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuCustomerShow = true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-input-group-append
              ><b-button
                class="btn btn-success ml-1"
                style="width: 110px !important"
                @click="search()"
              >
                <i class="fa fa-refresh"></i> Apply Filter</b-button
              ></b-input-group-append
            >
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend
              ><label style="width: 130px !important"
                >Item
              </label></b-input-group-prepend
            >
            <b-form-input
              v-model="tblData.itemname"
              placeholder="Item Name"
              @change="itemChange"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuItemShow = true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-input-group-append
              ><b-button
                class="btn btn-secondary ml-1"
                style="width: 110px !important"
                @click="clearFilter()"
              >
                <i class="fa fa-eraser"></i>Clear Filter</b-button
              ></b-input-group-append
            >
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="tblVendor"
        responsive
        striped
        hover
        style="font-size: smaller"
        :items="data"
        :fields="fields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="selectItem"
      >
        <template v-slot:cell(tglRetur)="data">
          {{ data.item.tglRetur | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(tglDeliver)="data">
          <span v-if="data.item.tglDeliver">
            {{ data.item.tglDeliver | moment("DD MMM YYYY") }}
          </span>
        </template>
        <template v-slot:cell(qtyRetur)="data">
          {{ data.item.qtyRetur | numFormat }}
        </template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
            <a href="javascript:void(0)" @click="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a
              href="javascript:void(0)"
              class="text-danger"
              @click="deleteConfirm(data.item)"
            >
              <i class="fa fa-trash"></i>
            </a>
          </div>
        </template>

        <template v-slot:custom-foot>
          <tr style="background-color: #d9edf7">
            <td colspan="6"><b>Total:</b></td>
            <td class="text-right">
              <b>{{ tblData.ttlRetur }}</b>
            </td>
            <td></td>
          </tr>
        </template>
      </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span> of
            {{ tblData.total | numFormat }} entries
          </div>
        </b-col>
        <b-col cols="2">
          <b-input-group>
            <b-input-group-prepend
              ><span class="pt-1 pr-2"
                >Limit per page</span
              ></b-input-group-prepend
            >
            <b-form-input
              v-model="limit"
              type="number"
              class="mr-2"
              v-b-tooltip.hover
              :title="`${limit} records`"
              style="max-width:80px; !important;"
            ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col cols="5">
          <b-pagination
            v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>

    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
    <b-modal
      v-model="showReport"
      size="xl"
      scrollable
      title="Preview as PDF"
      ok-only
    >
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal
      v-model="showDelConfirm"
      title="Delete Record?"
      :centered="true"
      @ok="deleteData"
    >
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">
        Warning: You can't undo this action.
      </p>
    </b-modal>
    <b-modal
      v-model="lkuCustomerShow"
      size="lg"
      :hide-footer="true"
      title="List of Customer"
      :centered="true"
    >
      <lku-customer
        @click="onSelectLkuCustomer"
        :customer_group="tblData.customer_group"
      ></lku-customer>
    </b-modal>
    <b-modal
      v-model="lkuItemShow"
      size="lg"
      :hide-footer="true"
      title="List of Master Item "
      :centered="true"
    >
      <lku-item
        @click="onSelectLkuItem"
        jasa="0"
        isactive="1"
        :formdata="itemList"
      ></lku-item>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, decimal } from "vuelidate/lib/validators";
import moment from "moment";
import retur from "../../apis/bakeryreturcustomer";
import item from "../../apis/bakeryitem";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import myNumber from "../../components/my-number";
import lkuCustomer from "../lookup/lkuCustomerGroup";
import lkuItem from "../lookup/lkuItemLazzy";
import customer from "../../apis/bakerycustomer";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: { Loading, lkuCustomer, lkuItem, myNumber },
  mixins: [validationMixin],
  validations: {
    frmdata: {
      itemno: { required },
      tglRetur: { required },
      qtyRetur: { required },
      sales: { required },
      customer_id: { required },
    },
  },
  data() {
    return {
      fields: [
        {
          key: "tglRetur",
          label: "Input Retur Date",
          thStyle: "width:150px",
          sortable: true,
        },
        {
          key: "CustCode",
          label: "Customer",
          thStyle: "width:100px",
          sortable: true,
        },
        {
          key: "CustName",
          label: "Customer Name",
          sortable: true,
        },
        {
          key: "partnumber",
          label: "Item",
          thStyle: "width:80px",
          sortable: true,
        },
        {
          key: "itemname",
          label: "Item Name",
          sortable: true,
        },
        {
          key: "itemcategory",
          label: "Item Category",
          sortable: true,
        },
        {
          key: "tglDeliver",
          label: "Order Date",
          thStyle: "width:120px",
          sortable: true,
        },
        {
          key: "qtyRetur",
          tdClass: "text-right",
          label: "Qty Retur",
          thStyle: "width:100px",
          sortable: true,
        },
        {
          key: "salesretur",
          label: "Retur By",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
      ],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        headcategory: null,
        ttlRetur: 0,
        customer_group: "",
        customer_id: "",
        CustName: "",
        itemcategory:"",
      },
      limit: 15,
      pagination: false,
      items: [],
      model: {},
      showFrm: false,
      frmdata: {
        qtyRetur: 0,
        itemno: "",
        customer_id: "",
        sales: "",
        tglRetur: moment().format("YYYY-MM-DD"),
        tglDeliver: "",
      },
      lkuItemShow: false,
      itemList: {},
      lkuCustomerShow: false,
      uanguser: this.$store.state.user.matauang,
      custgroup: [{ value: "", text: "-- ALL--" }],
      isLoading: false,
      showDelConfirm: false,
      showFilter: false,
      showList: true,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      activeStatus: [
        { value: "", text: "-- ALL --" },
        ,
        { value: "0", text: "Discontinued" },
        { value: "1", text: "Active/In Use" },
      ],
      jasaMaterial: [
        { value: "", text: "-- ALL --" },
        ,
        { value: "0", text: "Material " },
        { value: "1", text: "Service" },
      ],
      headCategories: [],
      itemCategories: [
        { text: '-- All --', value: '' }
      ],
    };
  },
  computed: {
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  watch: {
    limit: function (newVal) {
      setTimeout(() => {
        if (this.limit == newVal) {
          this.tblData.limit = newVal;
        }
      }, 500);
    },
  },

  created: async function () {
    try {
      const [custgroup,itemCategories] = await Promise.all([customer.group(),item.group()]);
      if (custgroup) {
        custgroup.map((data) => {
          this.custgroup.push({
            value: data.value,
            text: data.text,
          });
        });
      }
      if(itemCategories){
            itemCategories.map((data)=>{
              this.itemCategories.push({
                  value:data.nama,
                  text:data.nama
              });
          });
      }
    } catch (error) {
      this.isLoading = false;
      console.log("error : ", error);
      toastr.error(JSON.stringify(error), "ERROR MESSAGE");
    }
  },

  methods: {
    data: async function (ctx) {
      const tblOrder = {
        sortBy: this.tblData.sortBy,
        sortDesc: this.tblData.sortDesc,
      };
      this.pagination = false;
      const filter = this.$store.state.filter;
      let filtered = false;
      for (var key in filter.returlist) {
        this.tblData[key] = filter.returlist[key];
        filtered = true;
      }
      if (filtered === true) {
        if (!filter.returlist.tgl1) {
          this.tblData.tgl1 = "";
          this.tblData.tgl2 = "";
        }
        this.showFilter = filtered;
        delete filter.returlist;
        this.$store.commit("filter", filter);
        // this.$store.commit("filter", {});
        let autoRefresh = true;
        if (this.tblData.page == 1) {
          if (
            tblOrder.sortBy == this.tblData.sortBy &&
            tblOrder.sortDesc == this.tblData.sortDesc
          ) {
            autoRefresh = false;
          } else autoRefresh = false;
        }
        if (autoRefresh == false) {
          this.isLoading = true;
          this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
          try {
            const list = await retur.list(this.tblData);
            this.pagination = true;
            this.isLoading = false;
            return list;
          } catch (error) {
            this.isLoading = false;
            if (error.sql) {
              toastr.error(error.sql, "ERROR MESSAGE", 10000);
            } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
            } else if (error.message) {
              toastr.error(error.message, "ERROR MESSAGE", 10000);
            } else {
              toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
            }
          }
        }
      } else {
        this.isLoading = true;
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        try {
          const list = await retur.list(this.tblData);
          this.pagination = true;
          this.isLoading = false;
          return list;
        } catch (error) {
          this.isLoading = false;
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    selectItem(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    async reloaddata(val) {
      // this.isLoading = true;
      this.tblData.customer_group = val;
      this.tblData.customer_id = "";
      this.tblData.CustName = "";
      // this.isLoading = false;
    },
    refresh() {
      this.$refs.tblVendor.refresh();
    },
    search(ctx) {
      this.tblData.page = 1;
      this.refresh();
    },
    clearFilter(ctx) {
      this.tblData.itemno = "";
      this.tblData.itemname = "";
      this.tblData.customer_id = "";
      this.tblData.CustName = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.tglD1 = "";
      this.tblData.tglD2 = "";
      this.tblData.customer_group = "";
      this.tblData.itemcategory = "";
      this.refresh();
    },
    itemChange: function () {
      this.tblData.itemno = "";
    },
    customerChange: function () {
      this.tblData.customer_id = "";
    },
    saveFilter() {
      const keys = [
        "tgl1",
        "tgl2",
        "tglD1",
        "tglD2",
        "itemno",
        "itemname",
        "customer_id",
        "CustName",
        "itemcategory",
      ];
      let filtered = false;
      const returlist = {};
      for (const key in this.tblData) {
        if (keys.indexOf(key) >= 0 && this.tblData[key]) {
          filtered = true;
          returlist[key] = this.tblData[key];
        }
      }
      if (filtered === true) {
        returlist.page = this.tblData.page;
        returlist.limit = this.tblData.limit;
        returlist.sortBy = this.tblData.sortBy;
        returlist.sortDesc = this.tblData.sortDesc;
        const filter = this.$store.state.filter;
        filter.returlist = returlist;
        this.$store.commit("filter", filter);
      }
    },
    onSelectLkuItem: function (lkuData) {
      this.itemList = lkuData;
      this.lkuItemShow = false;
      this.tblData.itemno = lkuData.selected.itemno;
      this.tblData.itemname = lkuData.selected.itemname;
      this.frmdata.itemno = lkuData.selected.itemno;
      this.frmdata.itemname = lkuData.selected.itemname;
      this.frmdata.partnumber = lkuData.selected.partnumber;
      this.frmdata.iteminfo =
        lkuData.selected.itemname + "  |  " + lkuData.selected.partnumber;
      this.frmdata.unitsize = lkuData.selected.unitsize;
      this.frmdata.unitprice = lkuData.selected.unitprice;
    },
    onSelectLkuCustomer: async function (_selected) {
      this.tblData.CustName = _selected.CustName.trim();
      this.tblData.CustCode = _selected.CustCode;
      this.tblData.customer_id = _selected.customer_id;
      this.frmdata.customer_id = _selected.customer_id;
      this.frmdata.CustCode = _selected.CustCode;
      this.frmdata.CustName = _selected.CustName;
      this.frmdata.customer = `${_selected.CustName} | ${_selected.CustCode}`;
      this.lkuCustomerShow = false;
    },
    add() {
      this.saveFilter();
      router.push({ name: "bakery.returcustomerfrm" });
    },
    edit: function () {
      if (this.model.tablekey) {
        if (
          moment(this.model.tglReturn).format("YYYY-MM-DD") <
          this.$store.state.user.tglaktif
        ) {
          toastr.danger("Period has been CLOSED, EDIT not allowed!");
        } else {
          this.saveFilter();
          // router.push({name :'bakery.returcustomerfrm', params: { tablekey: this.model.tablekey, customer_id:this.model.tablekey, tglRetur: moment(this.model.tglRetur).format('YYYY-MM-DD') }});
          router.push({ name: "bakery.returcustomerfrm", params: this.model });
        }
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    deleteConfirm() {
      if (this.model) {
        this.showDelConfirm = true;
      } else {
        toastr.warn("Please select a row that want to be Delete!");
      }
    },
    deleteData: async function () {
      try {
        this.isLoading = true;
        await retur.remove(this.model);
        this.refresh();
        // const index= this.items.findIndex(r => (r.itemno==this.model.itemno));
        // this.items.splice(index, 1);
        this.isLoading = false;
      } catch (error) {
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },

    exportxls: async function () {
      this.isLoading = true;
      try {
        const response = await retur.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    closeFrm() {
      this.showList = true;
    },
    close() {
      router.push("home");
    },
  },
};
</script>
